import { render } from "./SchoolsView.vue?vue&type=template&id=25c4e77e&scoped=true"
import script from "./SchoolsView.vue?vue&type=script&lang=js"
export * from "./SchoolsView.vue?vue&type=script&lang=js"

import "./SchoolsView.vue?vue&type=style&index=0&id=25c4e77e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c4e77e"]])

export default __exports__